import { render, staticRenderFns } from "./GStudentRecordRecommendationLetter.vue?vue&type=template&id=92d3bca0&scoped=true&"
import script from "./GStudentRecordRecommendationLetter.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetter.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetter.vue?vue&type=style&index=0&id=92d3bca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3bca0",
  null
  
)

export default component.exports